import { render, staticRenderFns } from "./SSelectArticleTypeVisita.vue?vue&type=template&id=193b692b"
import script from "./SSelectArticleTypeVisita.vue?vue&type=script&lang=js"
export * from "./SSelectArticleTypeVisita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports